<template>
  <eg-modal
    :value="value"
    size="large"
    hide-title
    hide-footer
    persistent
    show-backdrop
  >
    <div class="metrics-no-data-modal">
      <img
        class="metrics-no-data-modal__image"
        src="@/assets/metrics/no-metrics.jpg"
        alt=""
      />
      <h2 class="metrics-no-data-modal__title">
        {{ $t("metrics.noMetricsTitle") }}
      </h2>
      <p class="metrics-no-data-modal__description">
        {{ $t("metrics.noMetricsDescription") }}
      </p>
      <a
        class="metrics-no-data-modal__link"
        href="#"
        @click.prevent="$emit('learn-more')"
      >
        {{ $t("metrics.learnMoreMetrics") }}
        <eg-icon icon="arrow-right" />
      </a>
      <div class="metrics-no-data-modal__actions">
        <eg-button type="secondary" @click="$emit('view-sample')">
          {{ $t("metrics.viewSampleData") }}
        </eg-button>
        <eg-button type="primary" to="/">
          {{ $t("metrics.uploadSubmissions") }}
        </eg-button>
      </div>
    </div>
  </eg-modal>
</template>

<script>
export default {
  name: "MetricsNoDataModal",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-no-data-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 24px;
  text-align: center;

  &__image {
    width: 280px;
    height: auto;
    object-fit: contain;
    margin-bottom: 24px;
  }

  &__title {
    color: var(--color-text-neutral-on-white, #1a2330);
    font-family: var(--typography-font-family-text-primary, Inter);
    font-size: 20px;
    font-weight: var(--typography-font-weight-fw-700, 700);
    line-height: 120%;
    margin: 0 0 12px;
  }

  &__description {
    color: var(--color-text-neutral-secondary, #566370);
    font-size: var(--typography-font-size-fs-300, 14px);
    line-height: 160%;
    max-width: 430px;
    margin: 0 0 16px;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--color-text-brand-default, #7c3aed);
    font-size: var(--typography-font-size-fs-300, 14px);
    font-weight: var(--typography-font-weight-fw-600, 600);
    text-decoration: none;
    margin-bottom: 24px;

    &:hover {
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    gap: 12px;
  }
}
</style>
